/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const Point = require('../../geometry/Point');
const HeaderNode = require('./HeaderNode');
const CellRange = require('./CellRange');
const { RowHeaderModel } = require('./HeaderModel');

const WIDTH = 900;
/**
 * @class RowHeaderNode

 * @extends Node
 * @constructor
 */
module.exports = class RowHeaderNode extends HeaderNode {
	constructor() {
		super();

		this._data = new RowHeaderModel();
	}

	newInstance() {
		return new RowHeaderNode();
	}

	getItemType() {
		return 'rowheadernode';
	}

	_assignName(id) {
		this.setName(`RowHeader${id}`);
	}

	getSectionData() {
		return this._data;
	}

	getInternalSize() {
		return new Point(this.getInternalWidth(), this.getSectionsSize());
	}

	getInternalWidth() {
		if (this.isItemVisible() === false) {
			return 0;
		}

		return RowHeaderNode.WIDTH + this.getMaxLevel() * 600;
	}

	static get WIDTH() {
		return WIDTH;
	}
};
